import { useEffect, useState } from "react";
import "./App.css";
import "./fonts-critical.css"; // enInter — body font, loaded first
import "./fonts.css";           // decorative fonts — non-blocking via font-display: swap
import { PageRoutes } from "./pages/PageRoutes";
import { Navbar } from "./components/sections/Navbar/Navbar";
import { Footer } from "./components/sections/Footer/Footer";
import { useLocation } from "react-router-dom";
import { I18nextProvider } from 'react-i18next';
import i18n from './utils/118n';
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { fetchUserMeta } from "./features/user/userMetaSlice";
import { RootState } from "./app/store";
import { restoreAuth } from "./features/auth/authSlice";
import { initializeCSRF } from "./features/csrf/csrfSlice";

function App() {
    const [showNavbarAndFooter, setShowNavbarAndFooter] = useState<boolean>(true);
    const location = useLocation();
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(initializeCSRF());
    }, [dispatch]);

    const { isAuthenticated } = useAppSelector(
        (state: RootState) => state.auth
    );

    const hiddenRoutes = [
        "/dashboard",
        "/dashboard/",
        "/dashboard/cards",
        "/dashboard/cards/",
        "/dashboard/settings",
        "/dashboard/settings/",
        "/dashboard/branches",
        "/dashboard/branches/",
        "/dashboard/analytics",
        "/dashboard/analytics/",
        "/dashboard/subscription",
        "/dashboard/subscription/",
        "/dashboard/support",
        "/dashboard/support/",
        "/card",
        "/card/",
    ];

    useEffect(() => {
        const token = localStorage.getItem('viart_token');
        if (token) {
            dispatch(fetchUserMeta());
        }
    }, [dispatch, isAuthenticated]);

    useEffect(() => {
        dispatch(restoreAuth());
    }, [dispatch, isAuthenticated]);


    useEffect(() => {
        const shouldHideNavbarAndFooter =
            hiddenRoutes.includes(location.pathname) ||
            /\/card(\/|$)/.test(location.pathname) ||
            /\/privacy-policy(\/|$)/.test(location.pathname) ||
            /\/terms-and-conditions(\/|$)/.test(location.pathname) ||
            /\/dashboard\/cards(\/|$)/.test(location.pathname) ||
            /\/dashboard\/employees(\/|$)/.test(location.pathname) ||
            /\/dashboard\/ratings(\/|$)/.test(location.pathname) ||
            /\/dashboard\/services(\/|$)/.test(location.pathname) ||
            /\/dashboard\/analytics(\/|$)/.test(location.pathname);
        setShowNavbarAndFooter(!shouldHideNavbarAndFooter);
    }, [location]);

    return (
        <I18nextProvider i18n={i18n}>
            {/* <HelmetProvider> */}
            <div className="bg-gray-900 font-enInter">
                {/* {showNavbarAndFooter && <ToTopButton />} */}
                {showNavbarAndFooter && <Navbar />}
                <PageRoutes />
                {showNavbarAndFooter && <Footer />}
            </div>
            {/* </HelmetProvider> */}
        </I18nextProvider>

    );
}

export default App;
